// 统一从后端响应中提取字段级错误或通用错误信息

export const formatErrorsObject = (errors: any): string | undefined => {
  if (errors && typeof errors === 'object') {
    try {
      const parts: string[] = [];
      Object.values(errors).forEach((messages: any) => {
        if (Array.isArray(messages)) {
          parts.push(messages.join('；'));
        } else if (typeof messages === 'string') {
          parts.push(messages);
        }
      });
      return parts.join('\n');
    } catch (_) {
      return undefined;
    }
  }
  return undefined;
};

export const getApiResponseErrorMessage = (resp: any, fallback: string): string => {
  const details = formatErrorsObject(resp?.errors);
  return details || resp?.message || fallback;
};

export const getAxiosErrorMessage = (error: any, fallback: string): string => {
  const resp = error?.response?.data;
  const details = formatErrorsObject(resp?.errors);
  return details || resp?.message || fallback;
};

